import type { Event } from '@sentry/react';

// V8 names the minified `sentryWrapped` listener frame after its receiver (`HTMLDocument.r`), which
// hides it from the ≤2-character heuristic behind `ignoreSentryInternalFrames`.
export const unqualifySentryWrapperFrame = {
  name: 'UnqualifySentryWrapperFrame',
  processEvent(event: Event) {
    if (!event.sdkProcessingMetadata?.insideSentryWrapped) return event;
    const frame = event.exception?.values?.[0]?.stacktrace?.frames?.[0];
    if (frame?.function) frame.function = frame.function.replace(/^\w+\./, '');
    return event;
  },
};
